import React, { useState } from 'react'
import { Box, Divider, Grid, Tab, Tabs } from '@material-ui/core'
import TabPanel from 'components/material/TabPanel'
import { Translate } from 'react-localize-redux'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useTeamFeature from 'hooks/useTeamFeature'
import TeaserChip from 'components/Teaser/TeaserChip'
import EventPlayers from './EventPlayers'
import { EVENT_SECTIONS } from 'constants/generalEvents'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const TabViewContainer = () => {
  const [activeTab, setActiveTab] = useState(EVENT_SECTIONS.generalEvent)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const { enabled: hasCreateGeneralEventEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.create_general_event_enabled
  )

  const handleChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  return (
    <Box m={2}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant={isMobile ? 'scrollable' : 'standard'}
        scrollButtons={isMobile ? 'auto' : 'off'}
        indicatorColor="primary"
      >
        <Tab
          label={
            <Grid alignItems="center" container justifyContent="center">
              <Grid item>
                <Translate id="matches.team-line-up" />
              </Grid>
              {!hasCreateGeneralEventEnabled && <TeaserChip />}
            </Grid>
          }
          value={EVENT_SECTIONS.generalEvent}
        />
      </Tabs>
      <Divider />
      <TabPanel
        value={activeTab}
        index={EVENT_SECTIONS.generalEvent}
        padding={1}
      >
        <EventPlayers />
      </TabPanel>
    </Box>
  )
}

export default TabViewContainer
